import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useParams  } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import initTreeView from '../../../services/initTreeView';
import { getApiData, getItemEnums, postApiData } from '../../../services/apiService';
import { productUnitData } from '../../../services/serviceHubStore';
import ProductUnitInputs from './ProductUnitInputs';
import ProductUnitInfo from './ProductUnitInfo';
import { TabView, TabPanel } from 'primereact/tabview';
import QRScannerComponent from '../../parts/QRScannerComponent';

export default function ProductUnitForm (){
    const { product_unit_id } = useParams();
    const { qr_code } = useParams();
    const { contact_id } = useParams();
    const [loading, setLoading] = useState(1);
    const navigate = useNavigate();
    const [errors, setErrors] = useState([]);
    const [page_title, setPageTitle] = useState('New PolarCare Units');
    const [form_data, setFormData] = useState(productUnitData);
    const [table_items, setTableItems] = useState([]);
    const [service_history, setServiceHistory] = useState([]);
    const [has_polarcare, setHasPolarCare] = useState(false);

    const [scannedData, setScannedData] = useState(null);
    const [showScanner, setShowScanner] = useState(true);
    const [scanError, setScanError] = useState(null);
   
    useEffect(() => {
        initTreeView()

        if(product_unit_id){
            setPageTitle('Edit PolarCare Units')
            fetchData(product_unit_id, 'id')
        }
        else if(qr_code){
            setPageTitle('PolarCare Units')
            fetchData(qr_code, 'qr-code')
        }
    }, []);
        
    useEffect(() => {
        displayTableItems()
    }, [
        service_history,
    ]);

        
    useEffect(() => {
        setHasPolarCare(Boolean(form_data.polarcare_plus))
    }, [form_data]);

    async function fetchData(ref_id, ref_by = 'id'){
        if(!ref_id){
            return
        }

        let endpoint = helpers.createServiceHubUrl(`v1/product-details/${ref_id}`)
        if(ref_by === 'qr-code'){
        endpoint = helpers.createServiceHubUrl(`public/v1/product-details/qrcode/${ref_id}`)
        }

        const res = await getApiData(endpoint, false)

        if(res){
            if(ref_by === 'id'){
                res.purchased_date = res.purchased_date ? new Date(res.purchased_date) : ''
                res.polarcare_start_date = res.polarcare_start_date ? new Date(res.polarcare_start_date) : ''
            }
            setFormData(res)
            setServiceHistory(res.service_history)

             if(ref_by === 'qr-code'){
                 setLoading(0)
             }
        }
        
        if(res.status === 'error'){
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/polarserv/product-units/list");
                }
            })
        }
    }

    async function submit(e, status = ''){
        e.preventDefault()
        
        let endpoint = helpers.createServiceHubUrl(`v1/product-details/create`)
        if(product_unit_id){
            endpoint = helpers.createServiceHubUrl(`v1/product-details/${product_unit_id}`)
        }
        const res = await postApiData(endpoint, form_data)

        setLoading(0)
        if(res.status === 'error'){
            if(res.data){
                setErrors( res.data );
            }else{
                setErrors([])
            }
            return
        }

        let id = product_unit_id;
        if(!id){
            id = res.data.id
        }

        Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            confirmButtonText: "OK",
        })
        .then((result) => {
            if (result.isConfirmed && !product_unit_id) {;
                window.location.replace(`/polarserv/product-units/${id}/form`);
                return;
            }
        })
    }

    function displayTableItems(){
        let items = []
        
        if (service_history?.length) {
            items = Object.entries(service_history).map(([key, data]) => {
                return(
                    <tr>
                        <td>{data.id}</td>
                        <td><Link to={`/polarserv/service-requests/${data.id}`}>{data.service_no}</Link></td>
                        <td>{data.request_date}</td>
                        <td>{data.service_type_name}</td>
                        <td>{data.sub_service_type_name ? data.sub_service_type_name : '---'}</td>
                        <td>{data?.member_names?.length ? helpers.concatenateText(data.member_names, ', ') : '---'}</td>
                        <td>{data.customer_name}</td>
                        <td>{helpers.displayServiceRequestStatusBadge(data.status, data.status_name)}</td>
                    </tr>
                )
            })
        }
        else{
            items = <tr>
                        <td colSpan={8} className='text-center'>No data to display.</td>
                    </tr>
        }

        setTableItems(items)
    }
    
    // Handler passed down to QRScannerComponent for successful scan
    const handleScanSuccess = (result) => {
        //console.log('result', result?.[0].rawValue)
        // if (result && result.text) {
        // setScannedData(result.text);
        // setShowScanner(false); // Stop scanning by unmounting the component
        // setScanError(null);
        // }
    };

    // Handler passed down for camera/scanning errors
    const handleScanError = (err) => {
        //console.error("Scanning Error:", err);
        // You can set a user-facing error message here
        setScanError("Failed to access camera or an error occurred during scan.");
    };
    
    // Resets the state to start a new scan
    const startNewScan = () => {
        setScannedData(null);
        setScanError(null);
        setShowScanner(true);
    };

    return (
        <div>
            <Layout page_title={page_title} menu="manage-product-units" breadcrumbs={ helpers.isAuthenticated() ? true : false} parent_link='/polarserv/product-units/list' parent_text="PolarServ">
                    <div className="content">
                        <div className="container-fluid pb-5" style={{position: 'relative'}}>
                            <Loader isLoading={loading}/>
                            <TabView>
                                <TabPanel header="Information">
                                    <form onSubmit={submit}>
                                        <div className="row mb-2">
                                            <div id="so-customer-section" className="col-lg-12">
                                                {
                                                    !qr_code ?
                                                    <ProductUnitInputs 
                                                        ref_id={product_unit_id} 
                                                        setLoading={setLoading}
                                                        setFormData={setFormData}
                                                        form_data={form_data}
                                                        errors={errors}
                                                    /> : 
                                                    <ProductUnitInfo
                                                        form_data = {form_data}
                                                    />
                                                }

                                                {/* {
                                                    <QRScannerComponent
                                                        onScan={handleScanSuccess}
                                                        onError={handleScanError}
                                                    />
                                                } */}
                                            </div>
                                        </div>

                                        <div className='text-right mt-3'>
                                            {
                                                !qr_code ?
                                                <button type='submit' className='btn btn-success ml-3'>Publish</button> : ''
                                            }

                                            {
                                                !qr_code ?
                                                    contact_id ?
                                                    <Link className='btn btn-outline-dark ml-3' to={`/customers/${contact_id}/product-units`}>Cancel</Link> :
                                                    <Link className='btn btn-outline-dark ml-3' to={'/polarserv/product-units/list'}>Cancel</Link>
                                                : ''
                                            }
                                        </div>
                                    </form>
                                </TabPanel>
                                {
                                    (product_unit_id || qr_code) && 
                                    <TabPanel header="Service History">
                                        <Link className='btn btn-primary mb-3' to={`/polarserv/service-requests/new?ProductUnit=${product_unit_id}`}><i className="fas fa-plus-circle mr-2" />New Service</Link>
                                        <div className='table-responsive'>
                                            <table className='table mb-0'>
                                                <thead className='thead-light'>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Service No</th>
                                                        <th>Request Date</th>
                                                        <th>Service Type</th>
                                                        <th>Sub Service Type</th>
                                                        <th>Assigned Technicians</th>
                                                        <th>Customer Name</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {table_items}
                                                </tbody>
                                            </table>
                                        </div>
                                        <hr />
                                        <div className='text-right mt-3'>

                                            {
                                                !qr_code ?
                                                    contact_id ?
                                                    <Link className='btn btn-outline-dark' to={`/customers/${contact_id}/product-units`}>Cancel</Link> :
                                                    <Link className='btn btn-outline-dark' to={'/polarserv/product-units/list'}>Cancel</Link>
                                                : ''
                                            }
                                        </div>
                                    </TabPanel>
                                }
                            </TabView>
                        </div>
                    </div>
            </Layout>
        </div>
    )
}